var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.logic)?_c('v-container',{staticStyle:{"max-width":"900px"},attrs:{"fluid":""}},[_c('Produkte',{attrs:{"logic":_vm.logic,"warenkorb":_vm.logic.warenkorb,"warenkorbGefuellt":_vm.logic.warenkorbGefuellt}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }